import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'

import actions from 'store/actions'
import { MODAL_ALERT_TYPES } from 'utils/consts'

import removeBtn from 'assets/images/remove.svg'

class TabContentAccess extends React.Component {
  async componentDidMount() {
    try {
      await this.props.fetchControllers()
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   * @param {Array<Number>} controllersID
   * @return {String}
   */
  getNameControllers = controllersID => {
    const controllers = this.props.controllers.objects || []

    return (
      controllers
        .filter(controller => {
          return controllersID.includes(controller.id)
        })
        .map(controller => controller.title)
        .join(', ') || 'отсутствуют'
    )
  }

  render() {
    const { groups } = this.props

    return (
      <>
        {!!groups.length ? (
          <div className='groups-list groups-list--fixed overflow-list'>
            {groups.map(group => (
              <div className='groups-list__group' key={group.id}>
                <div>
                  <div className='group-name'>{group.title}</div>
                  <div className='group-controllers'>
                    Точки доступа:{' '}
                    {group.access_object.length
                      ? this.getNameControllers(group.access_object)
                      : 'отсутствуют'}
                  </div>
                </div>
                <Button
                  className='btn--icon'
                  icon={true}
                  iconPicture={removeBtn}
                  action={() => this.props.removeGroup(group)}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className='not-exist not-exist--modal'>
            У сотрудника отсутствует доступ к объектам
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    controllers: state.controllersInfo,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchControllers: () => dispatch(actions.controllers.fetchControllers()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TabContentAccess)
